<template>
  <g>
    <path
      :d="'M' + x1 + ' ' + y1 + ' ' + x2 + ' ' + y2"
      stroke-width="16"
      stroke="#000"
      style="opacity: 0.01;"
    />

    <line
      v-bind="$props"
      class="arrow-line"
      stroke="#7F92A9"
      stroke-width="2"
      :marker-end="marker_end"
    />
  </g>
</template>

<script>
  export default {
    props: {
      x1: {
        type: [String, Number],
        default: 0
      },

      y1: {
        type: [String, Number],
        default: 0
      },

      x2: {
        type: [String, Number],
        default: 0
      },

      y2: {
        type: [String, Number],
        default: 0
      },

      marker_end: {
        type: String,
        default: 'url(#head)'
      }
    }
  };
</script>
